import { Table } from '@octano/global-ui';
import { useMemo } from 'react';
import { useContinuousEducationSectionsLoader } from '../hooks/ContinuousEducationSectionsLoader';
import useSectionsColumns from '../hooks/useSectionsColumns';

const SectionsTable = () => {
  const {
    result,
    loading,
    query,
    updateQuery,
  } = useContinuousEducationSectionsLoader();
  const columns = useSectionsColumns();

  const data = useMemo(() => {
    if (!result?.success) {
      return null;
    }
    return result.data;
  }, [result]);

  return (
    <div className="w-100">
      <Table
        data={data?.data ?? []}
        columns={columns}
        isLoadingResults={loading}
        pagination={{
          currentPage: query?.page || 1,
          itemsPerPage: query?.items_per_page || 10,
          onChangePage: (page) => {
            updateQuery({ ...query, page });
          },
          totalItems: data?.total || 0,
          totalPages: data?.total_pages || 0,
        }}
      />
    </div>
  );
};
export default SectionsTable;
